export default "__VITE_ASSET__cfd0cea9__"